// Refonte du suivi : lecture du drapeau suivi_v2 pour l'aiguillage, limitée
// dans le temps et gardée pour la session (l'écran actuel ne dépend jamais du
// nouveau code).
import { lireDrapeauSuiviV2 } from './suiviVersions';

// Drapeau lu une fois par session de la page, par cliente.
const drapeauxLus = new Map();
export const DELAI_DRAPEAU_MS = 2000;

/** Lit le drapeau, au plus DELAI_DRAPEAU_MS : au-delà (ou en erreur), « non ». */
export function lireDrapeauAvecDelai(clientId, { db, delai = DELAI_DRAPEAU_MS, lire = lireDrapeauSuiviV2 } = {}) {
  if (drapeauxLus.has(clientId)) return Promise.resolve(drapeauxLus.get(clientId));
  let minuterie;
  const delaiDepasse = new Promise((resolve) => { minuterie = setTimeout(() => resolve(null), delai); });
  const lecture = Promise.resolve()
    .then(() => lire(clientId, db ? { db } : {}))
    .then((valeur) => {
      const oui = valeur === true;
      drapeauxLus.set(clientId, oui);
      return oui;
    })
    .catch(() => null);
  return Promise.race([lecture, delaiDepasse]).then((valeur) => {
    clearTimeout(minuterie);
    return valeur === true;
  });
}

/** Pour les tests : oublie les drapeaux lus. */
export function oublierDrapeauxLus() {
  drapeauxLus.clear();
}

/** Valeur déjà lue pour cette cliente (true/false), ou undefined. */
export function drapeauConnu(clientId) {
  return drapeauxLus.has(clientId) ? drapeauxLus.get(clientId) : undefined;
}
